<template>
  <div class="mobile-create-bar">
    <el-button
      class="mobile-create-button"
      type="primary"
      :icon="MagicStick"
      @click="emit('create')"
    >
      创建角色
    </el-button>
  </div>
</template>

<script setup lang="ts">
  import { MagicStick } from '@element-plus/icons-vue';

  const emit = defineEmits<{
    create: [];
  }>();
</script>

<style scoped>
  .mobile-create-bar {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 20;
    display: none;
    height: calc(74px + env(safe-area-inset-bottom));
    box-sizing: border-box;
    padding: 16px 16px calc(16px + env(safe-area-inset-bottom));
    background: #fbf9ff;
  }

  .mobile-create-button.el-button {
    width: 100%;
    height: 42px;
    margin: 0;
    border: 0;
    border-radius: 16px;
    background: #6033e1;
    color: #fff;
    font-family: 'PingFang SC', 'Source Han Sans CN VF', 'Noto Sans SC', sans-serif;
    font-size: 13px;
    font-weight: 500;
    line-height: 18px;
    gap: 8px;
  }

  .mobile-create-button.el-button:hover,
  .mobile-create-button.el-button:focus {
    background: #6033e1;
    color: #fff;
  }

  .mobile-create-button :deep(.el-icon) {
    width: 12px;
    height: 12px;
    font-size: 12px;
  }

  @media (max-width: 767px) {
    .mobile-create-bar {
      position: static;
      display: block;
      flex: 0 0 auto;
      margin: 0 -16px;
      background: #fff;
    }
  }
</style>
